import React, { useState, useEffect } from 'react';
import { postData } from "../../../../../ApiServices/ApiService";
import { ORG_CONFIGURATION, ORG_INVOICE } from "../../../../../ApiServices/BaseURL";

const InvoiceSettingsController = () => {

    const [estimateSeries, setEstimateSeries] = useState([]);
    const [invoiceSeries, setInvoiceSeries] = useState([]);
    const [receiptSeries, setReceiptSeries] = useState([]);

    const [taxSgst, setTaxSgst] = useState(0);
    const [taxCgst, setTaxCgst] = useState(0);
    const [taxIgst, setTaxIgst] = useState(0);
    const [taxConvFee, setTaxConvFee] = useState(0);
    const [bookOpenBalance, setBookOpenBalance] = useState(0);
    const [narration, setNarration] = useState("");
    const [notes, setNotes] = useState("");
    const [overdueDays, setOverdueDays] = useState(0);

    const [loadingEstimate, setLoadingEstimate] = useState(false);
    const [loadingInvoice, setLoadingInvoice] = useState(false);
    const [loadingReceipt, setLoadingReceipt] = useState(false);
    const [loadingSettings, setLoadingSettings] = useState(false);

    const [errorEstimate, setErrorEstimate] = useState("");
    const [errorInvoice, setErrorInvoice] = useState("");
    const [errorReceipt, setErrorReceipt] = useState("");
    const [errorSettings, setErrorSettings] = useState("");

    const [showServiceEstimateSeries, setShowServiceEstimateSeries] = useState(true);
    const [showInvoiceSeries, setShowInvoiceSeries] = useState(false);
    const [showReceiptSeries, setShowReceiptSeries] = useState(false);

    const [editServiceEstimateSeries, setEditServiceEstimateSeries] = useState(false);
    const [editInvoiceSeries, setEditInvoiceSeries] = useState(false);
    const [editReceiptSeries, setEditReceiptSeries] = useState(false);

    const [selectedServiceEstimate, setSelectedServiceEstimate] = useState(null);
    const [selectedInvoiceSeries, setSelectedInvoiceSeries] = useState(null);
    const [selectedReceiptSeries, setSelectedReceiptSeries] = useState(null);

    useEffect(() => {
        fetchEstimateSeriesHistory();
        fetchInvoiceSeriesHistory();
        fetchReceiptSeriesHistory();
        fetchInvoiceSettings();
    }, []);

    const toggleServiceEstimateSeries = () => {
        setShowServiceEstimateSeries(true);
        setShowInvoiceSeries(false);
        setShowReceiptSeries(false);
        setEditServiceEstimateSeries(false);
        setEditInvoiceSeries(false);
        setEditReceiptSeries(false);
    };

    const toggleInvoiceSeries = () => {
        setShowInvoiceSeries(true);
        setShowServiceEstimateSeries(false);
        setShowReceiptSeries(false);
        setEditServiceEstimateSeries(false);
        setEditInvoiceSeries(false);
        setEditReceiptSeries(false);
    };

    const toggleReceiptSeries = () => {
        setShowReceiptSeries(true);
        setShowServiceEstimateSeries(false);
        setShowInvoiceSeries(false);
        setEditServiceEstimateSeries(false);
        setEditInvoiceSeries(false);
        setEditReceiptSeries(false);
    };

    const toggleUpdateServiceEstimateSeries = (item) => {
        setSelectedServiceEstimate(item);
        setEditServiceEstimateSeries(true);
        setEditInvoiceSeries(false);
        setEditReceiptSeries(false);
        setShowServiceEstimateSeries(false);
        setShowInvoiceSeries(false);
        setShowReceiptSeries(false);
        setSelectedInvoiceSeries(null);
        setSelectedReceiptSeries(null);
    };

    const toggleUpdateInvoiceSeries = (item) => {
        setSelectedInvoiceSeries(item);
        setEditInvoiceSeries(true);
        setEditServiceEstimateSeries(false);
        setEditReceiptSeries(false);
        setShowServiceEstimateSeries(false);
        setShowInvoiceSeries(false);
        setShowReceiptSeries(false);
        setSelectedServiceEstimate(null);
        setSelectedReceiptSeries(null);
    };

    const toggleUpdateReceiptSeries = (item) => {
        setSelectedReceiptSeries(item);
        setEditReceiptSeries(true);
        setEditServiceEstimateSeries(false);
        setEditInvoiceSeries(false);
        setShowServiceEstimateSeries(false);
        setShowInvoiceSeries(false);
        setShowReceiptSeries(false);
        setSelectedServiceEstimate(null);
        setSelectedInvoiceSeries(null);
    };

    const fetchSeriesHistory = async (actionType, setSeries, setLoading, setError) => {
        try {
            setSeries([]);
            setError('');
            setLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            const payLoad = {
                "action": actionType,
                "emp_id_auth": storedUserInfo?.emp_id,
            };

            //console.log('handleSearchClient header payload', payLoad);
            const response = await postData(ORG_CONFIGURATION, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setSeries(responseData?.dataJ);
                    } else {
                        setError(responseData?.info || 'Failed to fetch Client. Please try again.');
                    }
                } else {
                    setError(responseData?.info || 'Failed to fetch Client.');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setError('Unauthorized access. Your session may have expired. Please log in again.');
                } else {
                    setError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            } else {
                setError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setError(`Failed to fetch client. Please check your network connection and try again.`);
        } finally {
            setLoading(false);
        }
    };

    const fetchEstimateSeriesHistory = () => fetchSeriesHistory("ESTIMATE_SERIES_LIST", setEstimateSeries, setLoadingEstimate, setErrorEstimate);
    const fetchInvoiceSeriesHistory = () => fetchSeriesHistory("INVOICE_SERIES_LIST", setInvoiceSeries, setLoadingInvoice, setErrorInvoice);
    const fetchReceiptSeriesHistory = () => fetchSeriesHistory("RECEIPT_SERIES_LIST", setReceiptSeries, setLoadingReceipt, setErrorReceipt);

    const fetchInvoiceSettings = async () => {
        try {
            setErrorSettings('');
            setLoadingSettings(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            const payLoad = {
                "action": "INVOICE_SETTINGS_GET",
                "emp_id_auth": storedUserInfo?.emp_id,
            };

            //console.log('handleSearchClient header payload', payLoad);
            const response = await postData(ORG_INVOICE, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        const data = responseData.dataJ[0];

                        setTaxSgst(data?.acc_tax_sgst);
                        setTaxCgst(data?.acc_tax_cgst);
                        setTaxIgst(data?.acc_tax_igst);
                        setTaxConvFee(data?.acc_tax_conv_fee);
                        setBookOpenBalance(data?.acc_book_open_balance || 0);
                        setNarration(data?.acc_narration || "");
                        setNotes(data?.acc_notes || "");
                        setOverdueDays(data?.acc_overdue_days || 0);
                    } else {
                        setErrorSettings(responseData?.info || 'Failed to fetch Client. Please try again.');
                    }
                } else {
                    setErrorSettings(responseData?.info || 'Failed to fetch Client.');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setErrorSettings('Unauthorized access. Your session may have expired. Please log in again.');
                } else {
                    setErrorSettings(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            } else {
                setErrorSettings('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setErrorSettings(`Failed to fetch client. Please check your network connection and try again.`);
        } finally {
            setLoadingSettings(false);
        }
    };

    const invoiceRefresh = () => {
        fetchInvoiceSettings();
    }

    return {
        estimateSeries, loadingEstimate, errorEstimate,
        invoiceSeries, loadingInvoice, errorInvoice,
        receiptSeries, loadingReceipt, errorReceipt,
        taxSgst, taxCgst, taxIgst, taxConvFee, bookOpenBalance, narration, notes, overdueDays,
        loadingSettings, errorSettings,
        invoiceRefresh,
        fetchEstimateSeriesHistory, fetchInvoiceSeriesHistory, fetchReceiptSeriesHistory,
        showServiceEstimateSeries, showInvoiceSeries, showReceiptSeries,
        editServiceEstimateSeries, editInvoiceSeries, editReceiptSeries,
        selectedServiceEstimate, selectedInvoiceSeries, selectedReceiptSeries,
        toggleServiceEstimateSeries, toggleInvoiceSeries, toggleReceiptSeries,
        toggleUpdateServiceEstimateSeries, toggleUpdateInvoiceSeries, toggleUpdateReceiptSeries
    };
};

export default InvoiceSettingsController;
